import React               from 'react';
import classnames          from 'classnames';
import PropTypes           from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Loading = (props) => {
  const { loading } = props
  const clazz = classnames({
    'pcb-loading-overlay': true,
    hidden: !loading,
  });
  return (
    <div className={clazz}>
      <div className="spin">
        <FontAwesomeIcon icon="sync" spin />
      </div>
    </div>
  );
};

Loading.propTypes = {
  loading: PropTypes.bool.isRequired,
}

export default Loading
